import { createContext, useContext } from "react";

export const SimulationContext = createContext();

const useSimulationContext = () => useContext(SimulationContext);

export default useSimulationContext;
